import { Component, Input } from '@angular/core';

import { MainComponent } from './main.component';

@Component({
  selector: 'zx-layout-main-flex',
  templateUrl: './main.component.html',
  styleUrls: [ './main.component.css' ] 
})
export class MainFlexComponent extends MainComponent {
	@Input("sider-collapsed") isCollapsed = true;
	@Input("content-flex-layout") contentFlexLayout:boolean = true;
	@Input("footer-hidden") foolterHidden:boolean = true;
}